import { Button, Link, MenuItem, Paper, Select, TextField } from "@mui/material";
import { useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";

export default function StorylineSearch(){

    const [category, setCategory] = useState("all");
    const [searchQuery, setSearchQuery] = useState("");
    const [foundElements, setFoundElements] = useState([] as any[]);

    function handleSearchQueryChanged(event){
        setFoundElements([]);
        setSearchQuery(event.target.value);
    }

    function handleSearchClicked(){
        StorylineServerProxy.search(searchQuery, category).then(data => {
            setFoundElements(data.storyElements); 
        });
    }

    function handleCategoryChange(event){
        setFoundElements([]);
        setCategory(event.target.value);
    }

    function handleKeydown(event: KeyboardEvent){
        if(event.key == "Enter"){
          handleSearchClicked();
        }
      }    

    const archivePrefix = window.location.host.indexOf("localhost") != -1?"http://localhost:45828":"";

    return (
        <>
            <Paper elevation={4} sx={{padding: 4}}>
                <Select onChange={handleCategoryChange} value={category} sx={{ width: 1/10 }}>
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="Call for tender">Call for tenders</MenuItem>
                    <MenuItem value="Contract award">Contract awards</MenuItem>
                    <MenuItem value="News">News</MenuItem>
                    <MenuItem value="Job">Job</MenuItem>
                </Select>
                <TextField onKeyDown={handleKeydown} onChange={handleSearchQueryChanged}  sx={{ width: 7/10, marginLeft: 1, marginRight: 1 }}></TextField>
                <Button onClick={handleSearchClicked}  sx={{ width: 1/10, height: 55 }}>Search</Button>
            </Paper>
            
            <Paper elevation={4} sx={{padding: 4}}>
                {
                    foundElements.map(element => {
                        return (
                            <>
                                <Link href={element.link} target="_blank">{ element.title }</Link>
                                <br />
                                { element.timestampFormatted } - { element.type }
                                <br />
                                {  element.description.split("\n").map(text => {
                                    return (<>{text} <br/></>)
                                    })
                                }
                                { element.archive?"Archives: ": "No archive" }
                                { element.archive?
                                    element.archive.pdf?<><Link target="_blank" href={ archivePrefix + "/archive" + element.archive.pdf}>PDF</Link> - </>:"No PDF - ":""
                                }
                                { element.archive?
                                    element.archive.png?<><Link target="_blank" href={ archivePrefix + "/archive/" + element.archive.png}>PNG</Link> - </>:"No PNG - ":""
                                }
                                { element.archive?
                                    element.archive.html?<><Link target="_blank" href={ archivePrefix + "/archive/" + element.archive.html}>HTML</Link></>:"No HTML":""
                                }
                                <br />
                                <br />
                            </>
                        )
                    })
                }
            </Paper>            
        </>
    )
}